<template>
  <div class="iq-card pl-3 pr-3 pt-5 pb-5">
    <div id="report-2">
      <div class="">
        <table style="width: 100%">
          <tr>
            <table style="width: 100%; margin: 0; padding: 0">
              <tr>
                <th style="width: 25%">
                  <div class="logo">
                    <img
                      src="../../../assets/images/vehicle-solutions-logo-type1.png"
                      class="img-fluid"
                    />
                  </div>
                </th>
                <th style="width: 75%">
                  <div class="text-right">
                    <h4
                      style="
                        color: #3f414d;
                        font-family: 'Roboto Condensed';
                        font-size: 3rem;
                        font-weight: 700;
                        line-height: 1;
                        margin-bottom: 0;
                      "
                    >
                      Partner
                    </h4>
                    <h4
                      style="
                        color: #3f414d;
                        font-family: 'Roboto Condensed';
                        font-size: 3rem;
                        font-weight: 700;
                        line-height: 1;
                        margin-bottom: 0;
                      "
                    >
                      Income Report
                    </h4>
                    <p
                      style="
                        font-weight: 700;
                        margin-top: 20px;
                        margin-bottom: 0;
                      "
                    >
                      REPORT DATE RANGE
                    </p>
                    <p
                      style="font-weight: 700; margin-bottom: 0"
                      v-if="prosData.length > 0"
                    >
                      {{ propsFromDate | dateConvertDDMMYYYY }} to
                      {{ propsToDate | dateConvertDDMMYYYY }}
                    </p>
                  </div>
                </th>
              </tr>
            </table>
          </tr>
          <!-- 
          <tr>
            <table style="width: 100%; margin: 0; padding: 0">
              <tr>
                <th style="width: 100%">
                  <div class="text-left">
                    <h4
                      class="text-primary mb-0 py-auto"
                      style="
                        font-family: 'Roboto Condensed';
                        font-size: 3rem;
                        font-weight: 400;
                        line-height: 1.2;
                      "
                    >
                      {{ comGetDealerName }}
                    </h4>
                    <p class="mb-0">{{ comGetDealerAddress }}</p>
                  </div>
                </th>
              </tr>
            </table>
          </tr> -->

          <tr>
            <table style="width: 100%; margin: 0; padding: 0">
              <tr class="tbl-header-blue">
                <th>Customer Name</th>
                <th class="tbl-right">Net Amount Leased</th>
                <th class="tbl-right">Commission Inc GST</th>
                <th class="tbl-right">GST</th>
              </tr>
              <tr class="tbl-tr-no-data">
                <td colspan="4"></td>
              </tr>

              <template v-for="record in prosData">
                <tr class="tbl-border-bottom">
                  <td>
                    {{ record.client }}
                  </td>
                  <td class="tbl-right">
                    $ {{ record.totalDriveAwayCost | with-decimal}}
                  </td>
                  <td class="tbl-right">
                    $
                    {{ ( Number(record.reportingCommission)) |with-decimal}}
                  </td>
                  <td class="tbl-right">
                    $
                    {{ ((Number(record.reportingCommission) * Number(record.gstRate)) ) | with-decimal }}
                  </td>
                </tr>
              </template>

              <tr>
                <td></td>
                <td></td>
                <td class="tbl-right">Subtotal</td>
                <td class="tbl-right">
                  $
                  {{ Number(comGetSubTotal) - Number(comGetGSTTotal) |with-decimal}}
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td class="tbl-right">GST</td>
                <td class="tbl-right">$ {{ comGetGSTTotal |with-decimal}}</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td class="tbl-right">GRAND TOTAL</td>
                <td class="tbl-right">
                  $ {{ Number(comGetSubTotal) |with-decimal}}
                </td>
              </tr>
            </table>
          </tr>
          <tr>
            <table
              class="footer"
              style="width: 100%; margin-top: 100px; margin-bottom: 0"
            >
              <tr class="">
                <td>
                  <p class="mb-0">Questions?</p>
                  <p class="mb-0">Email us at admin@vehiclesolutions.com.au</p>
                  <p class="mb-0">or call us at (08) 8338 4427 (Option 1)</p>
                </td>
                <td class="tbl-right">
                  <h4
                    class="text-info mb-0 py-auto"
                    style="
                      font-family: 'Roboto Condensed';
                      font-size: 3rem;
                      font-weight: 700;
                      line-height: 1;
                    "
                  >
                    THANK
                  </h4>
                  <h4
                    class="text-info mb-0 py-auto"
                    style="
                      font-family: 'Roboto Condensed';
                      font-size: 3rem;
                      font-weight: 700;
                      line-height: 1;
                    "
                  >
                    YOU!
                  </h4>
                </td>
              </tr>
              <tr class="tbl-border-bottom4">
                <td colspan="4"></td>
              </tr>
              <tr>
                <td colspan="4" class="tbl-center">
                  <p>12 Greenhill Road, Wayville, SA 5034</p>
                </td>
              </tr>
            </table>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<style>
@page {
  /* size: A4 portrait; */
  /* margin: 0cm 0cm; */
  width: 210mm;
  height: 297mm;
  margin: 0px 20px 0px 20px;
}
@media print {
  body * {
    visibility: hidden !important;
    margin: 0;
    padding: 0;
  }
  #reportConsoleLeftSide {
    display: none !important;
  }
  #reportConsoleRightSide.col-lg-8,
  #reportConsoleRightSide.col-md-8 {
    -ms-flex: 0 0 100%;
    -webkit-box-flex: 0;
    flex: 0 0 100%;
    max-width: 100%;
  }
  #report-2,
  #report-2 * {
    visibility: visible !important;
  }
  #report-2 {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    margin: 0;
  }

  #report-2 .footer {
    position: relative;
    bottom: 0;
  }
}
#report-2 .logo img {
  height: 125px !important;
  width: auto;
  border-radius: 0px;
}
#report-2 .img-fluid {
  max-width: 100% !important;
  height: auto !important;
}
#report-2 .tbl-header-blue {
  background-color: var(--iq-info);
  color: var(--iq-white);
}
#report-2 .tbl-header-gray {
  background-color: var(--iq-border-light);
  color: var(--iq-title-text);
}
#report .tbl-header-blue th,
#report-2 .tbl-header-gray td,
#report-2 td {
  font-size: 1.1rem;
}
#report-2 tr th,
#report tr td {
  padding: 15px;
}
#report-2 tr.tbl-tr-no-data td {
  padding: 10px;
}
#report-2 tr.tbl-tr-no-data30-gray td {
  padding: 30px;
  background-color: var(--iq-border-light);
}
#report-2 .tbl-border-bottom {
  border-bottom: 1px solid var(--iq-border-light);
}
#report-2 .tbl-border-bottom3 {
  border-bottom: 3px solid var(--iq-border-light);
}
#report-2 .tbl-border-bottom4 {
  border-bottom: 3px solid var(--iq-info);
}
#report-2 .tbl-left {
  text-align: left;
}
#report-2 .tbl-right {
  text-align: right;
}
#report-2 .tbl-center {
  text-align: center;
}

#report-2 .footer {
  position: relative;
  bottom: 0;
}

#report-2 tr td p {
  font-size: 1.1rem;
}
.bg-info {
  background-color: var(--iq-info);
}
.text-info {
  color: #38afef;
}
.fw-600 {
  font-weight: 600;
}
.mb-0 {
  margin-bottom: 0;
}
</style>
<script>
import * as authService from '../../../services/auth.service'
import html2pdf from 'html2pdf.js'

export default {
  name: 'PartnerShipIncomeReport',
  props: ['prosData', 'propsFromDate', 'propsToDate'],
  components: {},
  data() {
    return {
      userData: {},
      data: []
    }
  },
  computed: {
    comGetSubTotal() {
      let arr = this.prosData
      let totalPrice = arr.reduce((accumulator, item) => {
        return accumulator + Number(item.reportingCommission)
      }, 0)
      return totalPrice
    },
    comGetGSTTotal() {
      let arr = this.prosData
      let totalGST = arr.reduce((accumulator, item) => {
        return (
          accumulator + Number(item.gstRate) * Number(item.reportingCommission)
        )
      }, 0)
      return totalGST
    }
  },
  methods: {
    fnExportToPDF() {
      html2pdf(document.getElementById('report-2'), {
        margin: 0.5,
        filename: 'referral-partner-income-report.pdf',
        jsPDF: { unit: 'cm', format: 'a4', orientation: 'portrait' }
      })
    }
  },
  created() {
    this.userData = authService.getUserFromToken()
  }
}
</script>